export default __webpack_public_path__ + "static/media/layout-1.d6de7ba6.jpg";